<template>
  <div v-if="currentUser.id">
    <h1 class="page-title">{{ $t('Statistic.title') }} {{ groupName }}</h1>
    <ul class="nav nav-tabs nav-tabs-fillup hidden-sm-down" data-init-reponsive-tabs="dropdownfx">
      <li class="nav-item col-4">
        <a href="#" :class="{ active: true }" data-toggle="tab" data-target="#period_report" aria-expanded="true">
          <span>{{ $t('Statistic.tabs.period_report') }} </span>
        </a>
      </li>
      <li class="nav-item col-4">
        <a href="#" :class="{ active: false }" data-toggle="tab" data-target="#statistic-global" class=""
           aria-expanded="false">
          <span>{{ $t('Statistic.tabs.global.title') }}</span>
        </a>
      </li>
    </ul>

    <div class="tab-content">
      <div class="tab-pane slide-left" :class="{ active: true }" id="period_report" aria-expanded="true">
        <Stats></Stats>
      </div>
      <div class="tab-pane slide-left" :class="{ active: false }" id="statistic-global" aria-expanded="false">
        <TabGlobalStatistic></TabGlobalStatistic>
      </div>
    </div>
  </div>
</template>

<script>
  import Stats from '@/components/stats/Stats';
  import TabGlobalStatistic from "./TabGlobalStatistic";
  import {mapGetters} from "vuex";

  export default {
    components: {
      Stats,
      TabGlobalStatistic
    },
    computed: {
      ...mapGetters({
        currentUser: 'auth/currentUser'
      }),
      groupName(){
        let groupName = ''
        if(this.currentUser.role == 'corporation_admin') {
          let entity = this.currentUser.entities[0]
          groupName = " - " + entity.corporation.name
        }
        return groupName
      }
    }
  }
</script>

<style>
  .nav-tabs ~ .tab-content {
    overflow: inherit;
  }
</style>



// WEBPACK FOOTER //
// src/components/stats/Index.vue